import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/**
 * ScrollDepth — adds subtle 3D perspective shift on scroll.
 *
 * @param {"lift" | "recede"} depth — "lift" pops section forward, "recede" pushes back
 * @param {number} intensity — 0 to 1, how dramatic the effect is
 */
export default function ScrollDepth({ children, depth = "lift", intensity = 0.5 }) {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });

    // Reduced motion check
    const prefersReduced =
        typeof window !== "undefined" &&
        window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

    const scale = useTransform(
        scrollYProgress,
        [0, 0.4, 0.6, 1],
        depth === "lift"
            ? [0.985, 1, 1, 0.985]
            : [1.005, 1, 1, 1.005]
    );

    if (prefersReduced) {
        return <div ref={ref}>{children}</div>;
    }

    return (
        <div ref={ref}>
            <motion.div style={{ scale, transformOrigin: "center center", willChange: "transform" }}>
                {children}
            </motion.div>
        </div>
    );
}
